import React from 'react'
import Iframe from 'react-iframe'
import Navbar from '../../components/navbar'

const Reach = () => {
  return (
    <div className='section-nav reach'>
      <Navbar />
      <div className='section-banner'>
        <div className='head'>Reach Us</div>
        <p>We are Present Across Geographies</p>
      </div>
      <div className='container' data-aos='fade-up' data-aos-delay='500'>
        <div className='row gy-4 map-row'>
          <div className='col-lg-6'>
            <div className='row gy-4'>
              <div className='col-md-6 box'>
                <div className='info-box'>
                  <i className='bi bi-geo-alt'></i>
                  <h3>Address</h3>
                  <p>
                    DLF Galleria, <br /> Action Area I, Newtown
                    <br />
                    Kolkata, West Bengal - 700156
                  </p>
                </div>
              </div>
              <div className='col-md-6 box'>
                <div className='info-box'>
                  <i className='bi bi-telephone'></i>
                  <h3>Call</h3>
                  <p>
                    (033) 4069-4101 <br />
                    <br />
                    <br />
                  </p>
                </div>
              </div>
              <div className='col-md-6 offset-md-3 box'>
                <div className='info-box'>
                  <i className='bi bi-envelope'></i>
                  <h3>Email Us</h3>
                  <p>info@rean.co.in</p>
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-6 map'>
            <Iframe
              url='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.933583809055!2d88.45819061480722!3d22.581587238331913!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02753dec56c46d%3A0x48bfcc53f95ea5ee!2sRean%20WaterTech%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1630416209006!5m2!1sen!2sin'
              width='100%'
              height='100%'
            />
          </div>
        </div>
      </div>

      <div
        className='row office-row gy-5'
        data-aos='fade-up'
        data-aos-delay='300'
      >
        <div className='heading'>Regional Offices</div>
        <div className='col-md-3 office'>
          <div className='name'>Bhopal</div>
          <div className='add'>
            Good Shepherd Colony,
            <br />
            Near Honda Show Room, Kolar Road,
            <br />
            Bhopal, Madhya Pradesh - 462042
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Balaghat</div>
          <div className='add'>
            Kumhari
            <br />
            Balaghat,
            <br />
            Madhya Pradesh - 481001
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Guna</div>
          <div className='add'>
            Pipal nagar,
            <br />
            Near navin vidhya mandhir school
            <br />
            Guna, Madhya Pradesh - 473001
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Neemuch</div>
          <div className='add'>
            Baghana sakthi nagar
            <br />
            Dhaneriya road
            <br />
            Neemuch, Madhya Pradesh - 458441
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Barwani</div>
          <div className='add'>
            Kasrawad,
            <br />
            Madhya Pradesh - 451228
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Khajuraho</div>
          <div className='add'>
            Vidhyadhar Colony Khajuraho(Chhatarpur)
            <br />
            Khajuraho, Madhya Pradesh - 471606
          </div>
        </div>

        <div className='col-md-3 office'>
          <div className='name'>Jodhpur</div>
          <div className='add'>
            Chopasani Housing Board
            <br />
            Jodhpur, Rajasthan - 342008
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reach
